import { Emitter, Event } from "../../../../../features/event-emitter"
import { TableName } from "../../../../../tables"
import { useSaleOperationService } from "../../../services/sale-operation-service/saleOperationService"
import { SalePaymentItem } from "../../../state/types"

export const useActions = () => {
    const { uploadPaymentReceipt } = useSaleOperationService()

    const submitReceipt = async (
        table: TableName,
        operationId: string,
        paymentItem: SalePaymentItem,
        receiptFile: File
    ) => {
        Emitter.emit(Event.DB_SUBMIT)

        await uploadPaymentReceipt(table, operationId, paymentItem, receiptFile)
        Emitter.emit(Event.DB_SUBMIT_DONE, false, false)
    }
    
    return {
        submitReceipt
    }
}
